import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Swal from "sweetalert2";

const CATEGORIES = [
  {
    label: "Web Development",
    sub: ["Frontend", "Backend", "Full Stack", "APIs"],
  },
  {
    label: "Data Science & AI",
    sub: ["Machine Learning", "Deep Learning", "NLP", "Computer Vision"],
  },
  {
    label: "Career Guidance",
    sub: ["Resume Tips", "Interview Prep", "Freelancing", "Job Search"],
  },
  {
    label: "Education & Training",
    sub: ["Live Classes", "Projects", "Mentorship", "Certifications"],
  },
  {
    label: "DevOps",
    sub: ["CI/CD", "Docker", "Kubernetes", "Cloud"],
  },
];

function BlogDetails() {
  const { slug } = useParams();
  const navigate = useNavigate();

  const [blog, setBlog] = useState(null);
  const [recentBlogs, setRecentBlogs] = useState([]);
  const [openCategory, setOpenCategory] = useState(null);
  const [sending, setSending] = useState(false);
const [comments, setComments] = useState([]);
  const [form, setForm] = useState({
    name: "",
    email: "",
    website: "",
    message: "",
  });

  // FETCH CURRENT BLOG
  useEffect(() => {
    Swal.fire({
      title: "Loading Blog...",
      text: "Please wait",
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    });

    fetch(`https://swiftintelli.com/api/get_single_blog.php?slug=${slug}`)
      .then((res) => res.json())
      .then((data) => {
        setBlog(data);
        Swal.close();
      })
      .catch((err) => {
        console.log(err);
        Swal.fire({
          icon: "error",
          title: "Failed to Load",
          text: "Unable to fetch blog details",
          confirmButtonColor: "#2563eb",
        });
      });
  }, [slug]);

  // FETCH RECENT BLOGS
  useEffect(() => {
    fetch("https://swiftintelli.com/api/get_blogs.php")
      .then((res) => res.json())
      .then((data) => {
        const arr = Array.isArray(data) ? data : data.blogs || [];
        const recent = arr
          .filter((b) => String(b.slug) !== String(slug))
          .slice(0, 5);
        setRecentBlogs(recent);
      })
      
      .catch((err) => console.log("Recent blogs error:", err));
  }, [slug]);

  const handleFormChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

const handleCommentSubmit = async () => {

  const { name, email, message } = form;

  if (!name.trim() || !email.trim() || !message.trim()) {

    Swal.fire({
      icon: "warning",
      title: "Required Fields Missing",
      text: "Please fill in Name, Email, and Message.",
      confirmButtonColor: "#1a56db",
    });

    return;
  }

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (!emailRegex.test(email)) {

    Swal.fire({
      icon: "warning",
      title: "Invalid Email",
      text: "Please enter a valid email address.",
      confirmButtonColor: "#1a56db",
    });

    return;
  }

  setSending(true);

  try {

    const res = await fetch(
      "https://swiftintelli.com/api/add_comment.php",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          blog_id: slug,
          name: form.name,
          email: form.email,
          website: form.website,
          message: form.message,
        }),
      }
    );

    const data = await res.json();

    if (data.status === "success") {

      Swal.fire({
        icon: "success",
        title: "Comment Submitted",
        text: "Your comment is waiting for admin approval.",
        confirmButtonColor: "#1a56db",
      });

      setForm({
        name: "",
        email: "",
        website: "",
        message: "",
      });

    } else {

      Swal.fire({
        icon: "error",
        title: "Failed",
        text: "Unable to submit comment",
        confirmButtonColor: "#1a56db",
      });

    }

  } catch (err) {

    console.log(err);

    Swal.fire({
      icon: "error",
      title: "Server Error",
      text: "Something went wrong",
      confirmButtonColor: "#1a56db",
    });

  } finally {

    setSending(false);

  }

};
useEffect(() => {

  fetch(
    `https://swiftintelli.com/api/get_blog_comments.php?blog_id=${slug}`
  )
    .then((res) => res.json())
    .then((data) => setComments(data))
    .catch((err) => console.log(err));

}, [slug]);
  if (!blog) return null;

  return (
    <>
      <Navbar />

      {/* HERO SECTION */}
      <section className="blog-details-hero">
        <h1>{blog.title}</h1>
        <p>{blog.category}</p>
      </section>

      {/* MAIN LAYOUT: content + sidebar */}
      <div className="blog-details-layout">
        {/* LEFT: Blog Content */}
        <main className="blog-details-main">
          <div className="blog-details">
            <img src={blog.image} alt={blog.title} />
            <div className="blog-details-content">
              <h2>{blog.title}</h2>
              <div
                className="blog-description"
                dangerouslySetInnerHTML={{ __html: blog.description }}
              />
            </div>
          </div>

          {/* DIVIDER */}
          <div className="blog-divider">
            <span>//</span>
          </div>

          {/* LEAVE A REPLY */}
          <div className="comment-section">
            <h2 className="comment-title">Leave a Reply</h2>
            <p className="comment-subtitle">
              Your email address will not be published. Required fields are
              marked <span className="required-star">*</span>
            </p>

            <div className="reply-form">
              {/* Row 1: Name + Email */}
              <div className="reply-form-row">
                <div className="reply-form-group">
                  <label className="reply-label">
                    Name <span className="required-star">*</span>
                  </label>
                  <input
                    type="text"
                    name="name"
                    className="reply-input"
                    placeholder="Your full name"
                    value={form.name}
                    onChange={handleFormChange}
                  />
                </div>
                <div className="reply-form-group">
                  <label className="reply-label">
                    Email <span className="required-star">*</span>
                  </label>
                  <input
                    type="email"
                    name="email"
                    className="reply-input"
                    placeholder="your@email.com"
                    value={form.email}
                    onChange={handleFormChange}
                  />
                </div>
              </div>

              {/* Row 2: Website */}
              <div className="reply-form-group">
                <label className="reply-label">Website</label>
                <input
                  type="url"
                  name="website"
                  className="reply-input"
                  placeholder="https://yourwebsite.com (optional)"
                  value={form.website}
                  onChange={handleFormChange}
                />
              </div>

              {/* Row 3: Message */}
              <div className="reply-form-group">
                <label className="reply-label">
                  Message <span className="required-star">*</span>
                </label>
                <textarea
                  name="message"
                  className="reply-textarea"
                  placeholder="Write your comment here..."
                  rows={6}
                  value={form.message}
                  onChange={handleFormChange}
                />
              </div>

              {/* Submit Button */}
              <button
                className="reply-submit-btn"
                onClick={handleCommentSubmit}
                disabled={sending}
              >
                {sending ? (
                  <>
                    <span className="btn-spinner" /> Sending...
                  </>
                ) : (
                  "Post Comment →"
                )}
              </button>
            </div>
            </div>

{/* APPROVED COMMENTS */}

<div className="blog-comments-list">

  <h3 className="blog-comments-heading">
    Comments ({comments.length})
  </h3>

  {comments.length === 0 && (
    <p className="blog-no-comments">
      No comments yet
    </p>
  )}

  {comments.map((c) => (

    <div
      key={c.id}
      className="blog-comment-card"
    >

      <div className="blog-comment-top">

        <div className="blog-comment-name">
          {c.name}
        </div>

        <div className="blog-comment-date">
          {c.created_at}
        </div>

      </div>

      <div className="blog-comment-message">
        {c.message}
      </div>

    </div>

  ))}

</div>

</main>
         

        {/* RIGHT: Fixed Sidebar */}
        <aside className="blog-sidebar">
          {/* Categories */}
          <div className="sidebar-widget">
            <h3 className="sidebar-widget-title">Categories</h3>
            <ul className="sidebar-category-list">
              {CATEGORIES.map((cat, idx) => (
                <li key={idx} className="sidebar-category-item">
                  <button
                    className={`sidebar-category-btn ${
                      openCategory === idx ? "active" : ""
                    }`}
                    onClick={() =>
                      setOpenCategory(openCategory === idx ? null : idx)
                    }
                  >
                    <span>{cat.label}</span>
                    <span
                      className={`dropdown-arrow ${
                        openCategory === idx ? "open" : ""
                      }`}
                    >
                      ▾
                    </span>
                  </button>
                  {openCategory === idx && (
                    <ul className="sidebar-sub-list">
                      {cat.sub.map((s, si) => (
                        <li key={si}>
                          <span className="sidebar-sub-item">— {s}</span>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Recent Blogs */}
          <div className="sidebar-widget">
            <h3 className="sidebar-widget-title">Recent Blogs</h3>
            <ul className="sidebar-recent-list">
              {recentBlogs.length === 0 && (
                <li className="sidebar-recent-empty">No recent blogs</li>
              )}
              {recentBlogs.map((rb) => (
                <li
                  key={rb.id}
                  className="sidebar-recent-item"
                  onClick={() => navigate(`/blog/${rb.slug}`)}
                >
                  {rb.image && (
                    <img
                      src={rb.image}
                      alt={rb.title}
                      className="sidebar-recent-img"
                    />
                  )}
                  <div className="sidebar-recent-info">
                    <span className="sidebar-recent-cat">{rb.category}</span>
                    <p className="sidebar-recent-title">{rb.title}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </aside>
      </div>

      <Footer />
    </>
  );
}

export default BlogDetails;
